import React from 'react';
import { DecoratorNode } from 'lexical';

// Forward declare the component - it will be available at runtime
// through the index.js barrel file
let MatchingEntityMentionComponent;

export const setMatchingEntityMentionComponent = (Component) => {
  MatchingEntityMentionComponent = Component;
};

class MatchingEntityMentionNode extends DecoratorNode {
  constructor(text, suggestions, sources, key) {
    super(key);
    this.text = text;
    this.suggestions = suggestions || [];
    this.sources = sources || [];
  }

  static importJSON(serializedNode) {
    return new MatchingEntityMentionNode(
      serializedNode.text,
      serializedNode.suggestions || [],
      serializedNode.sources || []
    );
  }

  exportJSON() {
    return {
      type: 'entity',
      version: 1,
      text: this.text,
      suggestions: this.suggestions,
      sources: this.sources
    };
  }

  static getType() {
    return 'entity';
  }

  static clone(node) {
    return new MatchingEntityMentionNode(node.text, node.suggestions, node.sources, node.__key);
  }

  // eslint-disable-next-line class-methods-use-this
  createDOM() {
    const span = document.createElement('span');
    span.style.color = 'var(--primary-default)';
    span.setAttribute('data-entity-mention', 'true');
    return span;
  }

  // eslint-disable-next-line class-methods-use-this
  updateDOM() {
    return false;
  }

  updateText(text) {
    const self = this.getWritable();
    self.text = text;
  }

  setSuggestions(suggestions) {
    const self = this.getWritable();
    self.suggestions = suggestions || [];
  }

  decorate() {
    if (!MatchingEntityMentionComponent) {
      return <span>{this.text}</span>;
    }

    return (
      <MatchingEntityMentionComponent
        nodeKey={this.getKey()}
        value={this.text}
        suggestions={this.suggestions}
        sources={this.sources}
      />
    );
  }

  getTextContent() {
    return this.text;
  }
}

export { MatchingEntityMentionNode };

export const $isMatchingEntityMentionNode = (node) => node instanceof MatchingEntityMentionNode;
